import React from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Checkbox } from '../ui/checkbox';
import { Badge } from '../ui/badge';
import { Eye, FileDown, Printer, Send } from 'lucide-react';
import useBranchLabels from '../../hooks/useBranchLabels';

export default function ReportCardStudentTable({
  students,
  loading,
  search,
  onSearchChange,
  selectedIds,
  allSelected,
  onToggleAll,
  onToggleOne,
  onPreview,
  onPdf,
  onPrint,
  onPublish,
}) {
  const { formatLabel } = useBranchLabels();
  return (
    <div className="rounded-2xl border border-border overflow-hidden bg-background">
      <div className="p-4 border-b border-border flex flex-wrap gap-3 items-center justify-between bg-muted/20">
        <div className="flex items-center gap-3">
          <h3 className="font-semibold text-foreground">Students</h3>
          <span className="text-sm text-muted-foreground">({students.length})</span>
        </div>
        <Input
          type="search"
          className="max-w-sm"
          placeholder="Search name, roll, admission…"
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
        />
      </div>

      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-muted/40">
            <tr>
              <th className="p-3 w-10">
                <Checkbox
                  checked={allSelected && students.length > 0}
                  onCheckedChange={(c) => onToggleAll(Boolean(c), students.map((s) => s.id))}
                />
              </th>
              <th className="p-3 text-left whitespace-nowrap">Roll No</th>
              <th className="p-3 text-left">Student Name</th>
              <th className="p-3 text-left whitespace-nowrap">Admission No</th>
              <th className="p-3 text-left">Section</th>
              <th className="p-3 text-left whitespace-nowrap">Attendance %</th>
              <th className="p-3 text-left whitespace-nowrap">Overall Grade</th>
              <th className="p-3 text-left whitespace-nowrap">Percentage</th>
              <th className="p-3 text-left">Status</th>
              <th className="p-3 text-right">Actions</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={10} className="p-10 text-center text-muted-foreground">Loading students…</td></tr>
            ) : students.length === 0 ? (
              <tr><td colSpan={10} className="p-10 text-center text-muted-foreground">No students found.</td></tr>
            ) : (
              students.map((s) => {
                const name = [s.first_name, s.last_name].filter(Boolean).join(' ') || '—';
                const pct = typeof s.percentage === 'number' ? s.percentage : Number(s.percentage || 0);
                const att = typeof s.attendance_percentage === 'number' ? s.attendance_percentage : Number(s.attendance_percentage || 0);
                const status = (s.status || '—');
                return (
                  <tr key={s.id} className="border-t border-border hover:bg-muted/15">
                    <td className="p-3">
                      <Checkbox checked={selectedIds.includes(s.id)} onCheckedChange={() => onToggleOne(s.id)} />
                    </td>
                    <td className="p-3 whitespace-nowrap">{s.roll_no || '—'}</td>
                    <td className="p-3 font-medium">{formatLabel(name, s)}</td>
                    <td className="p-3 whitespace-nowrap">{s.admission_no || '—'}</td>
                    <td className="p-3">{s.section_name || '—'}</td>
                    <td className="p-3 whitespace-nowrap">{att ? `${att.toFixed(2)}%` : '—'}</td>
                    <td className="p-3 whitespace-nowrap">{s.overall_grade || '—'}</td>
                    <td className="p-3 whitespace-nowrap">{pct ? `${pct.toFixed(2)}%` : '—'}</td>
                    <td className="p-3">
                      <Badge variant="outline" className="capitalize">{status}</Badge>
                    </td>
                    <td className="p-3">
                      <div className="flex justify-end gap-1 flex-wrap">
                        <Button type="button" size="sm" variant="ghost" onClick={() => onPreview(s)} title="Preview">
                          <Eye className="h-4 w-4" />
                        </Button>
                        <Button type="button" size="sm" variant="ghost" onClick={() => onPrint(s)} title="Print">
                          <Printer className="h-4 w-4" />
                        </Button>
                        <Button type="button" size="sm" variant="ghost" onClick={() => onPdf(s)} title="Download PDF">
                          <FileDown className="h-4 w-4" />
                        </Button>
                        <Button type="button" size="sm" variant="ghost" onClick={() => onPublish(s)} title="Publish">
                          <Send className="h-4 w-4" />
                        </Button>
                      </div>
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

